import React from 'react';
import { palettes, Theme } from '@indigo-ag/component-module';
import { faPaperclip, IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { createStylesHook } from 'shared/hooks/createStylesHook';
import { IconButton } from 'shared';
import i18next from 'core/i18n';

const useStyles = createStylesHook((theme: Theme) => ({
  containerDocument: {
    alignItems: 'center',
    border: '1px solid rgba(158, 158, 158, 0.498634)',
    borderRadius: 5,
    display: 'flex',
    justifyContent: 'space-between',
    padding: 10
  },

  w100: {
    width: '100%'
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },

  size16Black: {
    color: palettes.neutral[800],
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600
  },

  size14Blue: {
    color: palettes.coastal.core.mediumBlue,
    fontSize: theme.typography.pxToRem(14),
    marginRight: 10
  },

  rightIcon: {
    color: palettes.neutral['700'],
    cursor: 'pointer',
    fontSize: theme.typography.pxToRem(16)
  },

  size13Gray: {
    fontSize: theme.typography.pxToRem(13),
    color: palettes.neutral['700'],
    marginLeft: 22,
    marginTop: 5
  },

  optionContainer: {
    alignItems: 'center',
    display: 'flex',
    minHeight: '80px'
  },

  commentStyles: {
    marginTop: '12px !important',
    display: 'flex',
    textAlign: 'center'
  }
}));

interface DocumentProps {
  documentTitle: string;
  documentUrl?: string;
  content?: string;
  icon?: IconDefinition;
  onIconClick?: () => void;
  comment?: string;
  isVisible?: boolean;
}

export const Document: React.FunctionComponent<DocumentProps> = ({
  content,
  documentTitle,
  documentUrl,
  icon,
  onIconClick,
  comment,
  isVisible
}) => {
  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <div className={classes.w100}>
      <div className={classes.containerDocument}>
        <div className={classes.flexColumn}>
          <span>
            <FontAwesomeIcon icon={faPaperclip} className={classes.size14Blue} />
            {documentUrl ? (
              <a href={documentUrl} target="_blank" rel="noopener noreferrer" className={classes.size16Black}>
                {documentTitle}
              </a>
            ) : (
              <span className={classes.size16Black}>{documentTitle}</span>
            )}
          </span>
          {content && <span className={classes.size13Gray}>{content}</span>}
        </div>
        {icon ? (
          <div>
            <IconButton onClick={onIconClick} icon={icon} className={classes.rightIcon} />
          </div>
        ) : null}
      </div>
      {comment && isVisible ? (
        <span className={classes.commentStyles}>
          <span style={{ fontWeight: 'bold' }}>{i18next.t('comment')} : </span> {comment}
        </span>
      ) : null}
    </div>
  );
};
